export default "__VITE_ASSET__deb16a9c__"